import styled from 'styled-components/macro';

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  color: #FFFFFF;
  text-transform: uppercase;
`;

export const ScInput = styled.input`
  background: #171F2F;
  border: 1px solid #FFFFFF;
  width: 100%;
  color: #FFFFFF;
  border-radius: 5px;
`;

export const ScLabel = styled.label`
`;
